import { MxAction } from './action';
import { ActionContextType } from './action-context-type';
import { ActionDeviceVisibility } from './action-device-visibility';
import { ActionFilterType } from './action-filter-type';
import { ActionPurpose } from './action-purpose';
import { ActionUiZone } from './action-ui-zone';
import { ActionsContext } from './actions-context';

// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-ignore
Object.assign(window.mx.shell, {
	Action: MxAction,
	ActionContextType,
	ActionDeviceVisibility,
	ActionFilterType,
	ActionPurpose,
	ActionUiZone,
	ActionsContext,
});

export { MxAction, ActionContextType, ActionDeviceVisibility, ActionFilterType, ActionPurpose, ActionUiZone, ActionsContext };
